import Cookies from 'js-cookie';

class NativeApp {
  constructor(options = {}) {
    this.config = {
      body: document.body,
      vars: [],
      ...options
    };
  }

  init() {
    this.setNativeCookie();
  }

  setNativeCookie() {
    const params = this.getUrlParameters();
    if (params) {
      const { body } = this.config;
      let native = false;
      //   const useCookies = isSafariIncognito();

      if (params.native !== undefined) {
        // Check if we're being called via the app
        if (params.native) {
          Cookies.set('native', true, { expires: 730 });
          native = true;
        }
      }

      if (Cookies.get('native') || native) {
        body.classList.add('native-webview');
      }
    }
  }

  getUrlParameters(url) {
    const { vars } = this.config;
    let hash;
    const urlParameters = url ? `?${url.split('?')[1]}` : window.location.search;

    if (urlParameters) {
      const hashes = urlParameters.slice(1).split('&');
      for (let i = 0; i < hashes.length; i += 1) {
        hash = hashes[i].split('=');
        vars[hash[0]] = decodeURIComponent(hash[1]);
      }
      return vars;
    }
    return false;
  }
}

export default NativeApp;
